import { render, staticRenderFns } from "./PreguntaVariable.vue?vue&type=template&id=36aaf851&scoped=true&"
import script from "./PreguntaVariable.vue?vue&type=script&lang=js&"
export * from "./PreguntaVariable.vue?vue&type=script&lang=js&"
import style0 from "./PreguntaVariable.vue?vue&type=style&index=0&id=36aaf851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aaf851",
  null
  
)

export default component.exports